import { useQuery } from "@tanstack/react-query";
import { useUser } from "../../../contexts/UserContext";
import { getFamilyAccountBalancesAPI } from "../../../infrastructure/api/userBankAccounts";

export const useNetWorth = () => {
  const { currentUser } = useUser();

  return useQuery({
    queryKey: ["netWorth", currentUser?.uid],
    queryFn: async () => {
      if (!currentUser) {
        throw new Error("User not authenticated");
      }
      const accessToken = await currentUser.getIdToken();

      // Get 2 months of history to calculate change
      const balanceHistory = await getFamilyAccountBalancesAPI(accessToken, 2);

      // Calculate current net worth from latest balances
      const currentNetWorth =
        balanceHistory[0]?.balances.reduce(
          (sum, account) => sum + account.currentBalance,
          0,
        ) || 0;

      // Calculate previous net worth
      const previousNetWorth =
        balanceHistory[1]?.balances.reduce(
          (sum, account) => sum + account.currentBalance,
          0,
        ) || currentNetWorth * 0.95; // Fallback if no previous data

      return {
        netWorth: currentNetWorth,
        previousNetWorth,
      };
    },
    enabled: !!currentUser?.uid,
  });
};
